export class SystemField {
    id?:string;
    created_by_id?:string;
    created_date?:string;
    updated_by_id?:string;
    updated_date?:string;
    is_backup?:number; 
}
